import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { registrationService } from '../services/registrationService';

const { FiCheckCircle } = FiIcons;
const TOTAL_SEATS = 39;

export default function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [remainingSeats, setRemainingSeats] = useState(TOTAL_SEATS);
  const [registrants, setRegistrants] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const regs = await registrationService.getAll();

        setRegistrants(regs);
        setRemainingSeats(Math.max(0, TOTAL_SEATS - regs.length));
      } catch (error) {
        console.error('Failed to load registration data:', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (registrants.length === 0) return undefined;

    const interval = setInterval(() => {
      const names = registrants
        .map((registrant) => registrant.fullName?.split(' ')[0])
        .filter(Boolean);

      const randomName =
        names[Math.floor(Math.random() * names.length)] || 'คุณลูกค้า';

      setCurrentName(randomName);
      setIsVisible(true);

      setTimeout(() => setIsVisible(false), 5000);
    }, 39000);

    return () => clearInterval(interval);
  }, [registrants]);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, x: -50, y: 0 }}
          animate={{ opacity: 1, x: 0, y: 0 }}
          exit={{ opacity: 0, x: -50 }}
          className="fixed bottom-6 left-6 z-[100] pointer-events-none"
        >
          <div className="bg-white/95 backdrop-blur-md border-2 border-zinc-900 px-6 py-4 shadow-[10px_10px_0px_0px_rgba(0,0,0,0.1)] flex items-center gap-4">
            <div className="w-10 h-10 bg-brand-red text-white rounded-full flex items-center justify-center shrink-0">
              <SafeIcon icon={FiCheckCircle} className="w-5 h-5" />
            </div>

            <div className="flex flex-col">
              <p className="text-[14px] font-black text-zinc-900 leading-tight">
                {currentName} เพิ่งลงทะเบียนเรียนหลักสูตรนี้
              </p>

              <p className="text-[11px] text-brand-red font-black uppercase tracking-widest mt-1">
                เหลือที่นั่งเพียง {remainingSeats} ที่นั่งเท่านั้น จองเลย!!
              </p>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}